import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Collapse, Button } from 'react-bootstrap';
import cx from 'classnames';

//Images
import IconDefault from '/public/SiteIcons/defaultIcon.png';
import rulesIcon from '/public/SiteIcons/houseRulesArrow.svg';

import { url } from '../../../config';
import { CommonAngleDownIcon, CommonAngleUpIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';
import s from './ListingDetails.css';

const ListItem = ({ itemList, label, showLabel, hideLabel, icon, houseRulesIcon, locale }) => {

  const [open, setOpen] = useState(false);

  const handleClick = () => { setOpen(!open) };

  let count = 4, firstArray, restArray, dotString = false, itemListData;

  itemListData = itemList && itemList.length > 0 ? itemList.filter(o => o?.listsettings?.isEnable == "1") : [];

  if (itemListData) {
    firstArray = itemListData.slice(0, count);
    restArray = itemListData.slice(count, itemListData.length);
  }
  if (restArray && restArray.length > 0) {
    dotString = true;
  }

  return (
    <div className={cx(s.horizontalLineThrough)}>
      <div className={cx(s.space1)}>
        <p className={cx(s.sectionTitleText)}> {label} </p>
      </div>
      <div className={cx(s.spaceTop1, "listItemFlexContainer")}>
        {
          firstArray.map((item, key) => {
            if (item?.listsettings?.isEnable === "1") {
              return (
                <div
                  key={key}
                  className={cx(s.splitList, s.vtrTop, s.space2, "listItemFlexWrapper")}
                >
                  {icon && <span className={cx(s.listIcon, 'listIconRtl')}>
                    {
                      item?.listsettings?.icon ?
                      <img src={item?.listsettings?.icon} className={cx(s.imgSection)} /> :
                      item.listsettings.image ?
                        <img src={url + '/images/amenities/' + item.listsettings.image} className={cx(s.imgSection, 'darkModeFilterNone')} /> :
                        <img src={IconDefault} className={cx(s.imgSection)} />
                    }

                  </span>}
                  {houseRulesIcon && <span className='svgImg'>
                    <img src={rulesIcon} className={cx(s.rulesIconCss, 'rulesIconCssRTL')} />
                  </span>}
                  <span className={cx(s.text, s.overflowText, s.listContent)}>
                    {locale === "fr-FR" && item?.listsettings?.itemNameFR ? item?.listsettings?.itemNameFR : item?.listsettings?.itemName}
                  </span>
                </div>
              )
            }
          })
        }
        <Collapse className={cx(s.collapseContainer)} in={open}>
          <div>
            <div className='listCollapseContainer'>
              {
                restArray && restArray.length > 0 && restArray.map((item, key) => {
                  if (item?.listsettings?.isEnable === "1") {
                    return (
                      <p
                        key={key}
                        className={cx(s.splitList, s.vtrTop, "listItemFlexWrapper")}
                      >
                        {icon && <span className={cx(s.listIcon, 'listIconRtl')}>
                          {
                            item?.listsettings?.icon ?
                              <img src={item?.listsettings?.icon} className={cx(s.imgSection)} /> :
                            item.listsettings.image ?
                              <img src={url + '/images/amenities/' + item.listsettings.image} className={cx(s.imgSection, 'darkModeFilterNone')} /> :
                              <img src={IconDefault} className={cx(s.imgSection)} />
                          }
                        </span>}
                        {houseRulesIcon && <span className='svgImg'>
                          <img src={rulesIcon} className={cx(s.rulesIconCss, 'rulesIconCssRTL')} />
                        </span>}
                        <span className={cx(s.text, s.overflowText, s.listContent)}>
                          {locale === "fr-FR" && item?.listsettings?.itemNameFR ? item?.listsettings?.itemNameFR : item?.listsettings?.itemName}
                        </span>
                      </p>
                    )
                  }
                })
              }
            </div>
          </div>
        </Collapse>
        {
          dotString && <div className={cx(s.showHideMargin, 'listShowBtn')}>
            <Button
              bsStyle="link"
              type="button"
              className={cx(s.btn, s.btnLink, s.toggleLink, s.showHideBtn, s.noPadding)}
              onClick={() => handleClick()}
            >
              {open ? hideLabel : showLabel}
              {
                open && <CommonAngleUpIcon className1={s.toggleIcon} />
              }
              {
                !open && <CommonAngleDownIcon className2={s.toggleIcon} />
              }
            </Button>
          </div>
        }
      </div>
    </div>
  );
}


ListItem.propTypes = {
  itemList: PropTypes.arrayOf(PropTypes.shape({
    listsettings: PropTypes.shape({
      itemName: PropTypes.string,
      settingsType: PropTypes.shape({
        typeName: PropTypes.string
      }),
    }),
    spacesId: PropTypes.string,
  })).isRequired,
  label: PropTypes.string.isRequired,
};

ListItem.defaultProps = {
  itemList: [],
  showLabel: 'Show More Description',
  hideLabel: 'Hide Description',
  icon: false
};

const mapStateToProps = (state) => ({
  locale: state.intl.locale
});

export default connect(mapStateToProps)(withStyles(s)(ListItem));
